import { render, staticRenderFns } from "./TicketRoadster.vue?vue&type=template&id=0b6c1bd6&scoped=true"
import script from "./TicketRoadster.vue?vue&type=script&lang=js"
export * from "./TicketRoadster.vue?vue&type=script&lang=js"
import style0 from "./TicketRoadster.vue?vue&type=style&index=0&id=0b6c1bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c1bd6",
  null
  
)

export default component.exports